import { useEffect } from 'react';
import { useScript } from 'hooks/useScript';
import { useLocation } from 'react-router';

export function useMunchkinTracking() {
  const munchkinScriptStatus = useScript('//munchkin.marketo.net/munchkin.js');
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (munchkinScriptStatus === 'ready' && window.Munchkin) {
      window.Munchkin.init('004-QSK-624');
    }
  }, [munchkinScriptStatus]);

  useEffect(() => {
    if (window.Munchkin) {
      window.Munchkin.munchkinFunction('visitWebPage', {
        url:
          pathname === '/' ? '/signup' : `/signup${pathname.replace('/', '#')}`,
      });
    }
  }, [pathname]);

  return munchkinScriptStatus;
}
